








































import { defineComponent } from '@vue/composition-api'

import { IReceipt, Payment, Point } from '@/types/receipt'
import { ReceiptValidation } from '@/types/ocr'

import { AppAutocomplete } from '@/components/atoms'

type KeyValue = {
  key: string
  value: string
}

type Props = {
  receipt: IReceipt
  validation: ReceiptValidation
}

export default defineComponent({
  name: 'SummaryTable',
  components: {
    AppAutocomplete,
  },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props: Props, context) {
    const paymentList: KeyValue[] = Object.entries(Payment).map(
      ([key, value]) => {
        if (key === 'QUICKPAY') {
          return {
            key,
            value: '電子決済（QUICPay）',
          }
        }
        return {
          key,
          value,
        }
      },
    )
    const pointList: KeyValue[] = Object.entries(Point).map(([key, value]) => {
      return {
        key,
        value,
      }
    })

    const onSelectPaymentInfo = (payment?: KeyValue) => {
      let newPayment = null
      if (payment !== undefined) {
        if (payment.key === 'QUICKPAY') {
          newPayment = Payment.QUICKPAY
        } else {
          newPayment = payment.value
        }
      }
      const newReceipt = {
        ...props.receipt,
        payment: newPayment,
      }
      context.emit('update:receipt', newReceipt)
    }

    const onSelectPointInfo = (point?: KeyValue) => {
      let newPoint = null
      if (point !== undefined) {
        newPoint = point.value
      }
      const newReceipt = {
        ...props.receipt,
        point: newPoint,
      }
      context.emit('update:receipt', newReceipt)
    }

    const displayPayment = () => {
      const payment = props.receipt.payment || props.receipt.paymentOcr || ''
      if (payment === Payment.QUICKPAY) {
        return paymentList.find(p => p.key === 'QUICKPAY')?.value || ''
      }
      return payment
    }

    return {
      paymentList,
      pointList,
      onSelectPaymentInfo,
      onSelectPointInfo,
      displayPayment,
    }
  },
})
